import type { BloggerListItem, BloggerListQuery, BloggerStageCounts, Paginated } from '@ayub/shared'
import { apiGet } from '@/lib/api'

/** `docs/04-ui-ux.md` "Jadval (List ko'rinish)" — sahifada 50 ta. */
export const BLOGGERS_PAGE_SIZE = 50

/**
 * `GET /api/bloggers` javobi — `apps/server/src/api/routes/bloggers.ts`:
 * `Paginated<BloggerListItem> & { stageCounts: BloggerStageCounts }`.
 *
 * `stageCounts` — HAR QANDAY filtrdan (`stage` HAM, `q` HAM) mustaqil, doim BARCHA
 * blogerlar bo'yicha (`services/bloggers.ts`, `getStageCounts()`: "FILTRLARDAN mustaqil,
 * har doim BARCHA blogerlar bo'yicha"). Ya'ni qidiruv chiplaridagi sonlar qidiruv
 * yozilganda O'ZGARMAYDI — faqat qaysi chip "faol" ekani o'zgaradi.
 */
export interface BloggerListResponse extends Paginated<BloggerListItem> {
  stageCounts: BloggerStageCounts
}

function buildQueryString(query: BloggerListQuery): string {
  const params = new URLSearchParams()
  if (query.stage) params.set('stage', query.stage)
  if (query.q) params.set('q', query.q)
  if (query.page) params.set('page', String(query.page))
  if (query.pageSize) params.set('pageSize', String(query.pageSize))
  if (query.sort) params.set('sort', query.sort)
  if (query.order) params.set('order', query.order)
  const qs = params.toString()
  return qs.length > 0 ? `?${qs}` : ''
}

export function fetchBloggers(query: BloggerListQuery): Promise<BloggerListResponse> {
  return apiGet<BloggerListResponse>(`/bloggers${buildQueryString(query)}`)
}
